import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferOffer } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { SUC_OFF_XFER, ERR_OFF_XFER } from '../../../../utils/strings';

export const useOfferTransfer = () => {
  const { submit } = useCreateSubmission(TransferOffer, SUC_OFF_XFER, ERR_OFF_XFER);
  return submit;
};
